/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsFeaturedCollection = {
  init: function ($section) {
    var sectionData = window.PXUTheme.getSectionData($section);

    // Keep original theme behaviour, but make the data names compatible
    // with both single-collection and multi-collection sections.
    window.PXUTheme.jsFeaturedCollection = $.extend(this, sectionData);

    this.collection_style = sectionData.collection_style || sectionData.collection_layout;
    this.collection_layout = sectionData.collection_layout || sectionData.collection_style;
    this.collection_layout_mobile = sectionData.collection_layout_mobile || sectionData.collection_layout || sectionData.collection_style;

    this.products_per = Number(sectionData.products_per || 4);
    this.products_available = Number(sectionData.products_available || 0);
    this.products_limit = Number(sectionData.products_limit || 0);

    if (this.enable_masonry_layout && !this.align_height && this.collection_style === 'grid') {
      window.PXUTheme.applyMasonry();
    }

    // Nothing to initialise if neither desktop nor mobile layout is slider.
    if (this.collection_layout !== 'slider' &&
        this.collection_layout_mobile !== 'slider' &&
        this.collection_style !== 'slider') {
      return;
    }

    this.bindTabs($section);
    this.initialiseSectionSliders($section);
    this.bindResize($section);
  },

  initialiseSectionSliders: function ($section) {
    var $tabs = $section.find('.tabs-content');
    var $slidersToInit = $();

    // Multi-collection tab section.
    if ($tabs.length) {
      var $activeTab = $tabs.find('> li.active');

      if (!$activeTab.length) {
        $activeTab = $tabs.find('> li:first');
        $activeTab.addClass('active').show();
      }

      $slidersToInit = $activeTab.find('.slider-gallery');

      // If there is only one tab item, treat it as a normal single collection.
      if ($tabs.find('> li').length <= 1) {
        $slidersToInit = $tabs.find('.slider-gallery');
      }
    }

    // Single-collection section fallback.
    if (!$slidersToInit.length) {
      $slidersToInit = $section.find('.slider-gallery');
    }

    this.createSlider($slidersToInit);
  },

  bindTabs: function ($section) {
    var self = this;
    var $tabLinks = $section.find('ul.tabs li a');

    // Single collection has no tabs, or only one tab. Nothing to bind.
    if ($tabLinks.length <= 1) {
      return;
    }

    $tabLinks
      .off('click.featuredCollection')
      .on('click.featuredCollection', function (event) {
        event.preventDefault();

        var $tabLink = $(this);
        var targetSelector = $tabLink.attr('href');

        if (!targetSelector) {
          return;
        }

        var $targetTab = $section.find(targetSelector);

        if (!$targetTab.length) {
          return;
        }

        $tabLinks.removeClass('active');
        $tabLink.addClass('active');

        $section.find('.tabs-content > li').removeClass('active').hide();
        $targetTab.addClass('active').show();

        var $targetSlider = $targetTab.find('.slider-gallery');

        window.requestAnimationFrame(function () {
          self.createSlider($targetSlider);
          self.resizeSlider($targetSlider);
        });
      });
  },

  createSlider: function ($sliders) {
    if (!$sliders || !$sliders.length) {
      return;
    }

    var self = this;

    $sliders.each(function () {
      var $slider = $(this);

      if (!$slider.length) {
        return;
      }

      if ($slider.hasClass('flickity-enabled')) {
        self.resizeSlider($slider);
        $slider.addClass('is-flickity-ready');
        return;
      }

      var productsPerSlide =
        Number($slider.data('products-per-slide')) ||
        self.products_per;

      var productsLimit =
        Number($slider.data('products-limit')) ||
        self.products_limit;

      var productsAvailable =
        Number($slider.data('products-available')) ||
        self.products_available ||
        productsLimit;

      var showArrows = productsAvailable > productsPerSlide;

      $slider.flickity({
        lazyLoad: 2,
        freeScroll: true,
        imagesLoaded: true,
        draggable: true,
        cellAlign: 'left',
        wrapAround: showArrows,
        pageDots: false,
        adaptiveHeight: false,
        contain: true,
        prevNextButtons: showArrows,
        initialIndex: 0,
        arrowShape: arrowShape,
        on: {
          ready: function () {
            $slider.addClass('is-flickity-ready');

            window.requestAnimationFrame(function () {
              self.resizeSlider($slider);
            });
          }
        }
      });
      // Safety fallback: do not wait forever for Flickity ready.
setTimeout(function () {
  $slider.addClass('is-flickity-ready');
  self.resizeSlider($slider);
}, 300);
      $slider
        .off('settle.flickity.featuredCollection')
        .on('settle.flickity.featuredCollection', function () {
          self.resizeSlider($slider);
        });
    });
  },

  resizeSlider: function ($slider) {
    if (!$slider || !$slider.length || !$slider.hasClass('flickity-enabled')) {
      return;
    }

    $slider.flickity('resize');
  },

  bindResize: function ($section) {
    var self = this;

    $(window)
      .off('resize.featuredCollection')
      .on('resize.featuredCollection', function () {
        var $sliders = $section.find('.slider-gallery');

        $sliders.each(function () {
          var $slider = $(this);

          if ($slider.hasClass('flickity-enabled')) {
            self.resizeSlider($slider);
          } else {
            self.createSlider($slider);
          }
        });
      });
  },

  unload: function ($section) {
    var $slider = $section.find('.flickity-enabled');

    if ($slider.length) {
      $slider.flickity('destroy');
    }

    $(window).off('resize.featuredCollection');
    $section.find('ul.tabs li a').off('click.featuredCollection');
  }
}

/******/ })()
;